/* eslint-disable max-len */
/* eslint-disable react/no-multi-comp */
/* eslint-disable react/display-name */
/* eslint-disable react/jsx-max-props-per-line */
/* eslint-disable react/jsx-no-bind */

import React, {useEffect, useRef, useState} from "react";
import PropTypes from "prop-types";
import consumer from "../../../../app/assets/javascripts/channels/consumer";
import useComponentVisible from "../Site/components/useComponentVisible";

const DisplayNotification = ({customerId}) => {
  const containerRef = useRef(null);

  const [
    notifications,
    setNotifications
  ] = useState([]);

  const [
    notificationChannel,
    setNotificationChannel
  ] = useState(null);

  const {
    ref,
    "isComponentVisible": showNotifications,
    "setIsComponentVisible": setShowNotifications
  } = useComponentVisible(false);


  useEffect(() => {
    console.log("connecting to: DisplayNotificationChannel");
    const displayNotificationChannel = consumer.subscriptions.create({
      "channel": "DisplayNotificationChannel",
      "identifier": customerId
    }, {
      connected () {
      // Called when the subscription is ready for use on the server
        console.log("Connected to the display notification channel!");
      },

      disconnected () {
        // Called when the subscription has been terminated by the server
        console.log("Disconnected from the display notification channel!");
      },

      markAllAsRead () {
        console.log("marking all as read...");
        this.perform("mark_all_as_read", {"customer_id": customerId});
      },

      markAsRead (item) {
        this.perform("mark_read", {"notification_id": item.id});
      },

      received (data) {
        // Called when there's incoming data on the websocket for this channel
        console.log("Received data from the display notification channel data: ", data);
        setNotifications(data.notifications);
      }
    });

    setNotificationChannel(displayNotificationChannel);
  }, []);

  useEffect(() => {
    if (showNotifications) {
      document.documentElement.classList.add("no-scroll");
    } else {
      document.documentElement.classList.remove("no-scroll");
    }
    return () => {
      document.documentElement.classList.remove("no-scroll");
    };
  }, [showNotifications]);

  const toggleNotifications = () => {
    setShowNotifications(prevState => !prevState);
  };

  const handleMarkAllAsRead = () => {
    notificationChannel.markAllAsRead();
  };

  const handleMarkAsRead = (item) => {
    notificationChannel.markAsRead(item);
  };

  const handleOnClick = (item) => {
    handleMarkAsRead(item);
    if (item.link.length) {
      window.location = item.link;
    }
  };

  const handleOnClickContainer = (event) => {
    if (event.target === containerRef.current) {
      setShowNotifications(false);
    }
  };

  const hasUnread = () => notifications.some(notifiction => notifiction.read_at === null);

  const renderMarkAllAsReadButton = () => {
    if (hasUnread() && notifications.length > 1) {
      return (
        <button
          className="display-notification-btn-mark-all-read button-outlined-white button-xs whitespace-nowrap"
          onClick={handleMarkAllAsRead}
          type="button"
        >
          Mark All as Read
        </button>
      );
    }

    return null;
  };

  const renderNotifications = () => {
    if (!notifications) {
      return (
        <div className="p-2.5">
          You do not have any notifications
        </div>
      );
    }

    return (
      notifications.map(item =>
        <div
          className={`hover:no-underline focus:no-underline focus:outline-none cursor-pointer text-wrap p-2.5 flex items-center gap-4 transition-all duration-300 ${item.read_at ? "read bg-gray-50 hover:bg-gray-300" : "unread hover:bg-gray-100"}`}
          key={item.id}
          onClick={() => handleOnClick(item)}
        >
          <div className={`min-w-2.5 size-2.5 rounded-full ${item.read_at ? "bg-gray-400" : "bg-tangerine-100"}`} />
          <div className="flex flex-col">
            <div className="font-sans-demibold">
              {item.title}
            </div>
            {Boolean(item.description) &&
            <div className="leading-tight">
              {item.description}
            </div>}
          </div>
        </div>)
    );
  };

  return (
    <div className="display-notifications" ref={ref}>
      <div
        className="h-[67px] w-[50px] flex items-center justify-center"
        onClick={toggleNotifications}
      >
        <div className="size-7 relative display-notification-icon bg-icon-bell bg-center bg-no-repeat bg-[length:26px_26px] cursor-pointer">
          {hasUnread() && <div className="size-2.5 absolute right-0 mr-px bg-red-600 rounded-full" />}
        </div>
      </div>
      <div>
        {showNotifications &&
        <div
          className="z-1 absolute top-0 right-0 mr-0 480:mr-2.5 min-w-80 max-w-full pt-[60px] px-2.5 flex justify-stretch items-stretch max-h-[calc(100vh-60px)]"
          onClick={handleOnClickContainer}
          ref={containerRef}
        >
          <div className="bg-white rounded-md overflow-y-auto flex-1 shadow-[0_0_10px_0_rgba(0,0,0,0.2)]">
            <div className="p-2.5 flex items-center justify-between border-b border-gray-200">
              <div className="mt-1 font-serif leading-none">
                Notifications
              </div>
              {renderMarkAllAsReadButton()}
            </div>
            <div className="divide-y divide-gray-200">
              {renderNotifications()}
            </div>
          </div>
        </div>}
      </div>
    </div>);
};

DisplayNotification.propTypes = {"customerId": PropTypes.number.isRequired};

export default props => <DisplayNotification {...props} />;
